import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    Grid,
    Row,
    Col,
    OverlayTrigger,
    Popover
} from "react-bootstrap";
import {objectsConstants as OC} from 'redux/constant/objects-constant';
import {confirmAlert} from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {Card} from "components/Card/Card.jsx";
import {userActions} from '../../../redux/actions/user-actions';
import {roleActions} from '../../../redux/actions/role-actions';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import UserForm from "./UserForm";
import {FormInputs} from "components/FormInputs/FormInputs.jsx";
import {hasPermission} from 'helper/hasPermission';
import Confirmalertfordelete from '../../ThemeComponents/confirmAlertForDelete';
import {adminLabels} from '../../../redux/constant/admin-label-constant';
import OpenModalButton from '../../ThemeComponents/openModelButton';
import {helperFunctions as HF} from '../../../helper/helperFunctions';

var Modal = require('react-bootstrap-modal');

class AdminUserListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addModalUser: false,
            editModalUser: false,
            sorted: '',
            filtered: '',
            pageSize: 10,
            roles: [],
        };

        this.callEditUser = this.callEditUser.bind(this);
        this.deleteUser = this.deleteUser.bind(this);
        this.deleteConfirmUser = this.deleteConfirmUser.bind(this);
        this.usersPaginationData = this.usersPaginationData.bind(this);
        this.filterSearchHandle = this.filterSearchHandle.bind(this);
        this.handleUserSubmit = this.handleUserSubmit.bind(this);
    };

    async handleUserSubmit(userData, formType) {
        if (formType === 'add') {
            try {
                const res = await this.props.storeAdminUserCall({
                    ...userData,
                    password_confirmation: userData.confirm_password,
                    create_admin_user: true,
                    contact_info: true
                });
                this.setState({
                    addModalUser: false
                })
            } catch (e) {
                this.setState({
                    addModalUser: true
                })
            }
        } else if (formType === 'edit') {
            try {
                const res = await this.props.editUserCall({
                    ...userData,
                    email: userData.user_name,
                    password_confirmation: userData.confirm_password,
                    create_admin_user: true,
                    type: this.props.editUser.contact.type,
                    type_id: this.props.editUser.contact.type_id, contact_info: true,
                    _method: 'put'
                }, userData.id);
                this.setState({
                    editModalUser: false
                })
            } catch (e) {
                this.setState({
                    editModalUser: true
                })
            }
        }
    }

    filterSearchHandle(e) {
        this.setState({
            'filtered': e.target.value
        }, () => {
            this.refReactTable.fireFetchData()
        });

    }

    async callEditUser(id) {
        try {
            const res = await this.props.getUserCall(id);
            this.setState({editModalUser: true});
        } catch (e) {
            console.log("🚀 ~ file: AdminUsers.jsx ~ line 106 ~ AdminUserListPage ~ callEditUser ~ e", e)
        }
    }

    deleteUser(userId) {
        this.props.deleteUserCall(userId);
    }

    deleteConfirmUser(userId) {
        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <Confirmalertfordelete typeName="User" description="Are you sure to delete the admin user?"
                                           onClosePro={onClose} deleteType={() => this.deleteUser(userId)}/>
                )
            }
        })
    }

    async componentDidMount() {
        const res = await this.props.getAllRolesCall();
        this.setState({
            roles: res.roles.filter(item => item.value !== 3 && item.value !== 4)
        })
    }

    usersPaginationData(page, filter, sort, pageSize) {
        this.setState({pageSize: pageSize}, function () {
            this.props.getUsersCall(page, filter, sort, pageSize);
        })
    }

    componentDidUpdate(prevProps, nextProps) {
        // if ((prevProps.editUser !== this.props.editUser) && !this.props.loading) {
        //   this.setState({ editModalUser: true });
        // }
        if ((prevProps.storedUser !== this.props.storedUser) && !this.props.loading) {
            this.props.getUsersCall(this.props.current_page, '', '', this.state.pageSize);
        }
        if ((prevProps.updatedUser !== this.props.updatedUser) && !this.props.loading) {
            this.props.getUsersCall(this.props.current_page, '', '', this.state.pageSize);
        }
        if ((prevProps.deleteUser !== this.props.deleteUser) && !this.props.loading) {
            this.props.getUsersCall(this.props.current_page, '', '', this.state.pageSize);
        }
    }

    render() {
        const {filtered, roles} = this.state;
        const {editUser, usersData, pages, loading} = this.props;
        const columns = [
            {
                Header: "Users Listing",
                headerClassName: 'headerPagination',
                columns: [
                    {
                        Header: "Email",
                        accessor: "user_name",
                        className: "action-center"
                    },
                    {
                        Header: "Role",
                        accessor: "role.name",
                        className: "action-center",
                        sortable: false
                    },
                    // {
                    //   Header: "Image",
                    //   accessor: "image",
                    //   Cell: ({ row }) => (
                    //     <div>
                    //       {
                    //         row.image ? <img className="initialsLogo" alt="initialLogo" src={row.image.preview} /> : TF.initialsLogo(row.name)
                    //       }
                    //     </div>
                    //   ),
                    //   className: "action-center"
                    // },
                    {
                        Header: "Actions",
                        accessor: "id",
                        Cell: ({value}) => (
                            <div>
                                <OverlayTrigger placement="bottom" overlay={<Popover
                                    id="tooltip">{hasPermission('user-edit') ? 'Edit User' : adminLabels.DONT_ALLOW}</Popover>}>
                  <span>
                    {
                        hasPermission('user-edit') &&
                        <button type='button' className="editIcon orderDetailsAction"
                                onClick={() => this.callEditUser(value)}>&nbsp;</button>
                    }
                      {
                          !hasPermission('user-edit') &&
                          <button type='button' className="editIcon orderDetailsAction button_disabled">&nbsp;</button>
                      }
                  </span>
                                </OverlayTrigger>
                                <OverlayTrigger placement="bottom" overlay={<Popover
                                    id="tooltip">{hasPermission('user-delete') ? 'Delete User' : adminLabels.DONT_ALLOW}</Popover>}>
                  <span>
                    {
                        hasPermission('user-delete') &&
                        <button type='button' className="deleteIcon orderDetailsAction"
                                onClick={() => this.deleteConfirmUser(value)}>&nbsp;</button>
                    }
                      {
                          !hasPermission('user-delete') &&
                          <button type='button'
                                  className="deleteIcon orderDetailsAction button_disabled">&nbsp;</button>
                      }
                  </span>

                                </OverlayTrigger>
                            </div>
                        ),
                        className: "action-center",
                        sortable: false
                    }
                ]
            }
        ];

        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                ctTableResponsive
                                content={
                                    <div>
                                        <Grid fluid>
                                            <Row>
                                                <Col md={12}>
                                                    <div className="secHeading">Users List</div>
                                                </Col>

                                                <Col md={12}>
                                                    <div className="flexElem flexResponsive" style={{
                                                        "alignItems": "flex-start",
                                                        "justifyContent": "space-between"
                                                    }}>
                                                        <div className="">
                                                            <OpenModalButton
                                                                openModal={hasPermission('list-create') ? HF.openModal.bind(this, "addModalUser") : null}
                                                                classButton={['customBtn btnBlue', !hasPermission('list-create') ? 'button_disabled' : '']}
                                                                buttonName="Add User"
                                                                tooltipText={hasPermission('list-create') ? 'Add User' : adminLabels.DONT_ALLOW}
                                                                classIcon={['fa', 'fa-plus']}
                                                            />
                                                        </div>

                                                        <div className="custom-search-input">
                                                            <FormInputs
                                                                ncols={["col-md-12"]}
                                                                onChange={this.filterSearchHandle}
                                                                proprieties={[
                                                                    {
                                                                        type: "text",
                                                                        bsClass: "form-control",
                                                                        placeholder: "Search Users",
                                                                        onChange: this.filterSearchHandle,
                                                                        name: "filter"
                                                                    }
                                                                ]}
                                                            />
                                                        </div>
                                                    </div>
                                                </Col>

                                                <Col md={12} className="mt-md">
                                                    <ReactTable
                                                        noDataText='No user found'
                                                        data={usersData}
                                                        pages={pages}
                                                        loading={loading}
                                                        columns={columns}
                                                        defaultPageSize={10}
                                                        className="-striped listing responsive"
                                                        pageData={this.usersPaginationData}
                                                        ref={(refReactTable) => {
                                                            this.refReactTable = refReactTable;
                                                        }}
                                                        manual
                                                        onFetchData={(state, instance) => {
                                                            var sort = state.sorted.length === 0 ? '' : state.sorted[0].id + ',desc:' + state.sorted[0].desc;
                                                            state.pageData(state.page + 1, this.state.filtered, sort, state.pageSize);
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </Grid>

                                        {/*Add User Modal Start*/}
                                        {roles !== null &&
                                        <Modal show={this.state.addModalUser}
                                               onHide={HF.closeModal.bind(this, "addModalUser")}
                                               aria-labelledby="ModalHeader" backdrop={false}>
                                            <Modal.Header closeButton>
                                                <Modal.Title id='ModalHeader' className="headerTitle">Add
                                                    User</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <Card bsClass={["innerCard mb-none"]} content={
                                                            <UserForm
                                                                closeModel={HF.closeModal.bind(this, "addModalUser")}
                                                                formTypePro="add"
                                                                userPro={OC.USER}
                                                                handleUserSubmit={this.handleUserSubmit}
                                                                componentPro="adminUser"
                                                                roles={roles}
                                                            />
                                                        }/>
                                                    </div>
                                                </div>
                                            </Modal.Body>
                                        </Modal>
                                        }

                                        {/*Add User Modal End*/}

                                        {/*Edit User Modal start*/}
                                        {roles !== null &&
                                        <Modal show={this.state.editModalUser}
                                               onHide={HF.closeModal.bind(this, "editModalUser")}
                                               aria-labelledby="ModalHeader" backdrop={false}>
                                            <Modal.Header closeButton>
                                                <Modal.Title id='ModalHeader' className="headerTitle">Edit
                                                    User</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <Card bsClass={["innerCard mb-none"]} content={
                                                            <UserForm
                                                                closeModel={HF.closeModal.bind(this, "editModalUser")}
                                                                formTypePro="edit"
                                                                userPro={{
                                                                    ...editUser.user,
                                                                    first_name: editUser.contact && editUser.contact.first_name,
                                                                    last_name: editUser.contact && editUser.contact.last_name,
                                                                    role_id: editUser.role && editUser.role.id,
                                                                    role: editUser.role && editUser.role.name
                                                                }}
                                                                handleUserSubmit={this.handleUserSubmit}
                                                                roles={roles}
                                                            />
                                                        }/>
                                                    </div>
                                                </div>
                                            </Modal.Body>
                                        </Modal>
                                        }
                                        {/*Edit User Modal End*/}
                                    </div>
                                }/>
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    };
}


const mapDispatchToProps = dispatch => {
    return ({
        getUsersCall: (page, filter, sort, pageSize) => {
            dispatch(userActions.getUsersPagination(page, filter, sort, pageSize))
        },
        getUserCall: (id) => {
            return dispatch(userActions.getUser(id))
        },
        storeAdminUserCall: (userData) => {
            return dispatch(userActions.storeAdminUser(userData))
        },
        editUserCall: (userData, id) => {
            return dispatch(userActions.editUser(userData, id))
        },
        deleteUserCall: (id) => {
            dispatch(userActions.deleteUser(id))
        },
        getAllRolesCall: () => {
            return dispatch(roleActions.getUserRoles('user'))
        },
    });
};

function mapStateToProps(state) {
    const {editUser, loading, usersData, pages, storedUser, updatedUser, deleteUser, current_page} = state.userReducer;
    return {
        usersData, loading, pages, storedUser, updatedUser, editUser, deleteUser, current_page
    };
}

const AdminUsers = connect(mapStateToProps, mapDispatchToProps)(AdminUserListPage);
export default AdminUsers;



// WEBPACK FOOTER //
// ./src/components/Admin/Users/AdminUsers.jsx